/**
 * @generated SignedSource<<92c5d77b9fb3628068374d2bcf387330>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { Fragment, ReaderFragment } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type IssueStatusCell$data = {
  readonly id?: string;
  readonly status: {
    readonly name: string | null | undefined;
    readonly statusCategory: {
      readonly statusCategoryId: string;
    } | null | undefined;
    readonly statusId: string;
  };
  readonly " $fragmentType": "IssueStatusCell";
};
export type IssueStatusCell$key = {
  readonly " $data"?: IssueStatusCell$data;
  readonly " $fragmentSpreads": FragmentRefs<"IssueStatusCell">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "isInlineEditingEnabled"
    }
  ],
  "kind": "Fragment",
  "name": "IssueStatusCell",
  "selections": [
    {
      "condition": "isInlineEditingEnabled",
      "kind": "Condition",
      "passingValue": true,
      "selections": [
        {
          "kind": "ScalarField",
          "name": "id"
        }
      ]
    },
    {
      "concreteType": "JiraStatus",
      "kind": "LinkedField",
      "name": "status",
      "plural": false,
      "selections": [
        {
          "kind": "ScalarField",
          "name": "name"
        },
        {
          "kind": "ScalarField",
          "name": "statusId"
        },
        {
          "concreteType": "JiraStatusCategory",
          "kind": "LinkedField",
          "name": "statusCategory",
          "plural": false,
          "selections": [
            {
              "kind": "ScalarField",
              "name": "statusCategoryId"
            }
          ]
        }
      ]
    }
  ],
  "type": "JiraStatusField"
};

(node as any).hash = "437005b12e4b057a438ab749ffd12538";

export default node;
